/* eslint-disable react/prop-types */

import { Box, Flex, Price, PrimaryButton, Text } from "flicket-ui";
import { ReactNode, useState } from "react";
import * as actions from "~features/nonseated-reservation/store/actions";
import {
  Store,
  useNonSeatedReservationStore,
} from "../store/non-seated-reservation-store";
import { IReleaseTicket } from "../nonseated-reservation.types";
import { useRouter } from "next/router";
import sum from "lodash/sum";
import pluralize from "pluralize";
import { organization } from "~test-setup/data";
import { useOrganization } from "~hooks";
import { useCreateGAOrder } from "../nonseated.hooks";

type Mode = "has-selection" | "no-selection";

interface IExperienceSalesLayout {
  id: string;
  releaseId: string;
  children?: ReactNode;
  hideFooterDuringMode?: Mode[];
  ticketType?: IReleaseTicket;
}

export const ExperienceSalesLayout = ({
  id,
  releaseId,
  children,
  hideFooterDuringMode,
  ticketType,
}: IExperienceSalesLayout) => {
  const { hasFeature } = useOrganization();
  const router = useRouter();

  const [submitting, setSubmitting] = useState(false);

  const handleOrderCreation = useCreateGAOrder({
    releaseId,
  });

  const selectedTickets = useNonSeatedReservationStore(
    (state) => state.selectedTicketTypes[id] ?? []
  );

  const mode: Mode =
    selectedTickets.length > 0 ? "has-selection" : "no-selection";

  async function handlePrimaryAction() {
    if (mode === "has-selection") {
      setSubmitting(true);
      await handleOrderCreation(
        selectedTickets.filter((tt) => tt.type === "ticket") ?? [],
        selectedTickets.filter((tt) => tt.type === "addon") ?? [],
        // activePromotions?.[0]?.promotion?.id,
        // TODO: handle promotions
        undefined,
        (errorMessage) => {
          console.error(errorMessage);
          setSubmitting(false);
        }
      );
      // actions.resetInitialState();
    } else {
      actions.updateSelectedTicketTypes({
        id,
        ticketType,
        quantity: 1,
      });

      void router.push(`/events/${id}/reservation`);
    }
  }

  const ticketCount = sum(selectedTickets.map((tt) => tt.quantity));
  const ticketPrice = sum(selectedTickets.map((tt) => tt.quantity * tt.price));

  const showFooter =
    !hideFooterDuringMode?.includes(mode) && hasFeature("showExperienceSales");
  return (
    <Box width={1}>
      {children}

      {showFooter && (
        <Box position="fixed" zIndex="sticky" bottom={0} width={1} bg="white">
          <Flex
            flex={1}
            alignItems="center"
            justifyContent="space-between"
            px={3}
            h={80}
            boxShadow="card"
          >
            <Box>
              {mode === "has-selection" && (
                <>
                  {" "}
                  <Text variant="small">
                    {ticketCount} {pluralize("ticket", ticketCount)}
                  </Text>
                  <Text variant="header.S">
                    <Price price={ticketPrice} />
                  </Text>
                </>
              )}
            </Box>

            <PrimaryButton
              minW={{ sm: 330 }}
              width={{ _: "50%", sm: "auto" }}
              onClick={() => {
                void handlePrimaryAction();
              }}
              isLoading={submitting}
            >
              {mode === "has-selection" ? "Buy now" : "Select"}
            </PrimaryButton>
          </Flex>
        </Box>
      )}
    </Box>
  );
};
